angular.module('businessAnalytics', ['angularutilities'])
.directive('resizeContainer', function($window, $timeout, $rootScope) {
	return {
		link: function (scope, element, attr){
			var w = angular.element($window);
			jQuery(window).off('resize');
			w.off('resize');
			w.bind('resize', function() {
				resizeContainer();
				scope.$apply();
			});			
			
			function resizeContainer() {									
				var navHeight = 54;
				var newHeight = jQuery(window).height() - navHeight;
				var childHeight = newHeight - 68;		
				jQuery('.baContainer').css('maxHeight', newHeight + 'px');
				jQuery('.baContainer').css('minHeight', newHeight + 'px');	
				jQuery('#baFrame').css('height', (childHeight - 18) + 'px');
			}				
			resizeContainer();		
		}
	};
})
.service('businessAnalyticsService', function($http, hostUrl) {
	var self = this;
	var urlPfx = '2/factndx/';
	return {
		getBAToken: getBAToken,
		getBADashboard: getBADashboard
	};
	
	function getBAToken(user) {
		var url = urlPfx + globalConfig.factory.id + '/BA/Token/User/' + user;
		return $http.get(hostUrl + url)
			.then(getDataSuccess)
			.catch(getDataFailed);
		
		function getDataSuccess(response) {
			return response.data;
		}
		
		function getDataFailed(error){
			return undefined;
		}
	}
	
	function getBADashboard(dashboardNdx) {
		var url = urlPfx + globalConfig.factory.id + '/BA/DashboardNdx/' + dashboardNdx;
		return $http.get(hostUrl + url)
			.then(getDataSuccess)
			.catch(getDataFailed);
		
		function getDataSuccess(response) {
			return response.data;
		}
		
		function getDataFailed(error){
			return undefined;
		}
	}
})

.controller('businessAnalyticsCtrl', function($scope, $timeout, $sce, $location, navigationService, businessAnalyticsService) {
	var model = {};
	function init() {
		if (!$scope.navList || !globalConfig || !globalConfig.factory){
			$timeout(function() {init();}, 10);
		} else {
			var found = false;
			var pathSplit = $location.path().split('/'); 
			var index = pathSplit[pathSplit.length - 1];
			for (var i = 0; i < $scope.navList.length; i++){
				if ($scope.navList[i].id == index){
					$scope.dashboardView = $scope.navList[i];
					model = $scope.navList[i];
					found = true;
					break;
				}
			}
			if (!found){
				$timeout(function() {init();}, 10);
			} else {
				var dashboardNdx = -1;
				if (typeof model.config.ndx !== undefined) {
					dashboardNdx = model.config.ndx;
				}
				navigationService.setActiveDashboard($scope.dashboardView.id, $scope.dashboardView.name, 'Spend Summary Dashboard');
				businessAnalyticsService.getBADashboard(dashboardNdx).then(function(data) {
					var dashboardURL = data.dashboardUrl;
					businessAnalyticsService.getBAToken(data.username).then(function(data) {
						var iframeUrl = data.rootUrl + dashboardURL + data.token;
						$scope.frameSrc = $sce.trustAsResourceUrl(iframeUrl);
					});
				}); 
			}
		}
	}

	init();
});
